import React from 'react'
import { Link } from 'react-router-dom'

/** Every related-entity row is a link — nothing terminates without a next
 * click. Used for Org→Provider, Org→Patient, Provider→Patient, and back
 * links on all three entity detail pages. */
export function RelatedEntityList({
  items, emptyLabel,
}: {
  items: Array<{ id: string; to: string; primary: React.ReactNode; secondary?: React.ReactNode }>
  emptyLabel: string
}) {
  return (
    <div className="row-list">
      {items.map((item) => (
        <Link key={item.id} to={item.to} className="row" style={{ textDecoration: 'none', color: 'inherit' }}>
          <span>{item.primary}</span>
          {item.secondary && <span className="muted">{item.secondary}</span>}
        </Link>
      ))}
      {items.length === 0 && <div className="empty">{emptyLabel}</div>}
    </div>
  )
}
